<template>
    <div id="project-overview" class="mx-10 ma-5">    
        <h1>{{ title }}</h1>         
        <v-divider class="mt-5"></v-divider>
    </div>    
  </template>
  
  <script>
    export default {
      props:['title'],
      name:"breadcrumbs",
      data () {
        return {   
        
        }
      },
       methods: {         
      }  
    }
  </script>